import { applyEmergencyDepartmentJourneyExplanation } from './emergencyDepartmentJourneyExplanation.js';
import { applyMaternityJourneyExplanation } from './maternityJourneyExplanation.js';
import { applyJourneyBatch3Explanation } from './journeyBatch3Explanations.js';
import { applyJourneyBatch8Explanation } from './journeyBatch8Explanations.js';
import { applyJourneyTerminologyCoverage } from './journeyTerminologyCoverage.js';

const CORE_STAGE_PHRASES = Object.freeze({
  maternity: Object.freeze([
    Object.freeze([]),
    Object.freeze(['birthCentre', 'inductionOfLabour']),
    Object.freeze([
      'maternityTriage',
      'labourWard',
      'deliverySuite',
      'ctg',
      'epidural',
      'artificialRuptureOfMembranes',
      'assistedBirth',
      'caesareanSection',
    ]),
    Object.freeze([
      'skinToSkin',
      'delayedCordClamping',
      'postnatalWard',
      'breastfeedingSupport',
      'neonatalUnit',
      'neonatalIntensiveCare',
    ]),
  ]),
  outpatients: Object.freeze([
    Object.freeze(['referral']),
    Object.freeze(['review', 'bloodTests', 'scan']),
    Object.freeze(['resultsPending', 'followUpAppointment', 'safetyNetting']),
  ]),
  'emergency-department': Object.freeze([
    Object.freeze(['triage', 'observations', 'news2', 'oxygenSaturations', 'analgesia']),
    Object.freeze([
      'resus',
      'cannula',
      'bloodTests',
      'ecg',
      'scan',
      'ctScan',
      'monitoring',
      'sepsis',
      'review',
    ]),
    Object.freeze(['admission', 'stable', 'safetyNetting']),
  ]),
  'imaging-diagnostics': Object.freeze([
    Object.freeze(['investigations', 'scan', 'reasonableAdjustments', 'bloodTests']),
    Object.freeze(['scan', 'cannula', 'contrast', 'ctScan', 'mriScan', 'monitoring']),
    Object.freeze(['resultsPending', 'diagnosis', 'followUp']),
  ]),
  'inpatient-ward': Object.freeze([
    Object.freeze(['admission', 'observations', 'news2', 'baseline', 'cannula', 'iv']),
    Object.freeze([
      'wardRound',
      'handover',
      'review',
      'mdt',
      'carePlan',
      'onCall',
      'prn',
      'analgesia',
      'antiemetic',
      'mobilise',
      'fluidBalance',
      'vtePrevention',
      'escalationPlan',
      'oxygenSaturations',
      'monitoring',
      'aki',
      'urinaryCatheter',
    ]),
    Object.freeze([
      'medicallyFitForDischarge',
      'dischargePlanning',
      'takeHomeMedicines',
      'dischargeSummary',
      'safetyNetting',
      'followUpAppointment',
    ]),
  ]),
  'critical-care-visitor': Object.freeze([
    Object.freeze([
      'criticalCare',
      'intensiveCareUnit',
      'highDependencyUnit',
      'familyVisiting',
      'monitoring',
      'organSupport',
      'ventilator',
      'sedation',
      'intubation',
      'tracheostomy',
      'centralLine',
      'arterialLine',
      'feedingTube',
    ]),
    Object.freeze([
      'stable',
      'wardRound',
      'handover',
      'review',
      'vasopressors',
      'delirium',
      'weaning',
    ]),
    Object.freeze(['stepDown', 'criticalCareOutreach', 'recoveryAfterIcu']),
  ]),
});

const MATERNITY_STAGE_REFERENCES = Object.freeze([
  Object.freeze({ linkIds: ['where-to-go'], questionIndexes: [0, 2] }),
  Object.freeze({ linkIds: ['preparing-for-birth'], questionIndexes: [1, 4] }),
  Object.freeze({ linkIds: ['when-to-contact', 'visiting-and-support'], questionIndexes: [3, 7] }),
  Object.freeze({ linkIds: ['feeding-support', 'going-home'], questionIndexes: [5, 6, 8] }),
]);

export function applyCoreJourneyStageQuality(templateId, stages = []) {
  const phraseStages = CORE_STAGE_PHRASES[templateId];
  if (!phraseStages || phraseStages.length !== stages.length) return stages;

  const enrichedStages = stages.map((stage, index) => {
    const maternityReferences = templateId === 'maternity' ? MATERNITY_STAGE_REFERENCES[index] : null;
    return {
      ...stage,
      phraseKeys: [...phraseStages[index]],
      ...(maternityReferences || {}),
    };
  });

  if (templateId === 'emergency-department') {
    return applyJourneyTerminologyCoverage(templateId, applyEmergencyDepartmentJourneyExplanation(enrichedStages));
  }
  if (templateId === 'maternity') {
    return applyJourneyTerminologyCoverage(templateId, applyMaternityJourneyExplanation(enrichedStages));
  }
  return applyJourneyTerminologyCoverage(templateId, applyJourneyBatch8Explanation(templateId, applyJourneyBatch3Explanation(templateId, enrichedStages)));
}
